import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPage } from "../../../features/privacy";

export const Route = createFileRoute("/$lang/_layout/privacy-policy")({
  component: PrivacyPage,
});
